import { render, staticRenderFns } from "./InAppPurchaseOffersForm.vue?vue&type=template&id=9cc560c4&scoped=true&"
import script from "./InAppPurchaseOffersForm.vue?vue&type=script&lang=js&"
export * from "./InAppPurchaseOffersForm.vue?vue&type=script&lang=js&"
import style0 from "./InAppPurchaseOffersForm.vue?vue&type=style&index=0&id=9cc560c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc560c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCheckbox,VChip,VFileInput,VSelect,VTextField})
